<template>
  <div style="height: 100%">
    <!--基础设施-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;margin-bottom: 10px;" v-if="!label">
        <span
          style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span style="">设备分布</span>
    </div>
    <label style="margin-top: 15px;font-weight: bold;margin-left: 30px;" v-if="label">故障统计</label>
    <pie-chart :data="data" :extendData="extendData" ref="pieChart" style="height: 90%"
               v-if="data.length >0"></pie-chart>
    <no-data style="margin-top: 12%;" v-else></no-data>
  </div>
</template>

<script>
import PieChart from '@/components/echarts/PieChart';
import {getClassifiedDeviceCategory} from '@/network/device-category';
import NoData from "@/components/NoData";

export default {
  name: "Infrastructure",
  components: {PieChart, NoData},
  props: {
    label: {
      type: Boolean,
      default: true
    },
    spaceId: {
      type: String,
      default: () => null
    },
    tagId: {
      type: String,
      default: null,
    }
  },
  watch: {
    spaceId() {
      this.getData();
    },
    tagId() {
      this.getData();
    },
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getInfrastructure:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getInfrastructure')
  },
  data() {
    return {
      data: [],
      extendData: null,
    }
  },
  mounted() {
    this.getData();
    this.extendData = {
      series: [{
        radius: ["62%", "40%"],
        center: ['30%', '45%']
      }, {
        center: ['30%', '45%'],
        hoverAnimation: false,
        label: {
          show: false
        },
      }],
      legend: {
        right: '15%',
        top: '1%',
        bottom: '8%',
        type: 'scroll',
        pageIconInactiveColor: "#999",
        pageIconColor: "#01EFFD",
        pageTextStyle: {
          color: "#01EFFD"
        },
        pageIconSize: [12, 12]
      },
    }
  },
  methods: {
    getData() {
      getClassifiedDeviceCategory(this.spaceId, this.tagId,null).then(res => {
        if (res.code === 0) {
          this.data = res.data;
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
